import * as React from 'react';
import { useGetMembersGroupUserQuery } from "../../../apis/MembersGroupUser.api";
import { PrimaryMembersGroupUser, MembersGroupUser } from "../../../types/models/MembersGroupUser";
import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import UserName from "../../../../auth/components/user/UserDetail/UserName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: MembersGroupUser;
};

export const MembersGroupUserNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<><MembersGroupName id={ data?.membersGroupId }/>
                    {data?.ownedMembersGroupId && <> | </> }<UserName id={ data?.ownedMembersGroupId }/>
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const MembersGroupUserName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetMembersGroupUserQuery(PrimaryMembersGroupUser.fromId(id))
    return (<MembersGroupUserNameDisplay data={data}/>)
}

export default MembersGroupUserName;
